// Global Instructions Rule Applied!

export const SET_ACTIVE_RECORD = 'activeRecords/SET_ACTIVE_RECORD' as const
export const UPDATE_ACTIVE_RECORD = 'activeRecords/UPDATE_ACTIVE_RECORD' as const
export const REMOVE_ACTIVE_RECORD = 'activeRecords/REMOVE_ACTIVE_RECORD' as const
export const REGISTER_RECORD_USAGE = 'activeRecords/REGISTER_RECORD_USAGE' as const
export const UNREGISTER_RECORD_USAGE = 'activeRecords/UNREGISTER_RECORD_USAGE' as const
